/**
 * Krátke pípnutie pri novej webovej objednávke (R38).
 *
 * PREČO WEB AUDIO A NIE ZVUKOVÝ SÚBOR:
 *   Je to jeden tón na pol sekundy. Súbor by znamenal ďalšiu požiadavku,
 *   ďalšiu vec v `public/` a ďalšiu vec, ktorá sa môže nenačítať; prehliadač
 *   ho vie vyrobiť sám.
 *
 * Prehliadače prehrajú zvuk až po tom, čo používateľ na stránke niečo urobil.
 * Dispečer v paneli klikal, takže to v praxi funguje — a keď nie, pípnutie
 * ticho nevyjde a vizuálne upozornenie ostáva. Preto sa chyba iba prehltne:
 * zlyhanie zvuku nesmie zhodiť obrazovku s objednávkami.
 */
let kontext = null;

export function zapipaj() {
  try {
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return;

    if (!kontext) kontext = new Audio();
    // Po prepnutí záložky býva kontext uspatý.
    if (kontext.state === "suspended") kontext.resume?.();

    const oscilator = kontext.createOscillator();
    const hlasitost = kontext.createGain();

    oscilator.type = "sine";
    oscilator.frequency.value = 880;
    hlasitost.gain.setValueAtTime(0.0001, kontext.currentTime);
    hlasitost.gain.exponentialRampToValueAtTime(0.12, kontext.currentTime + 0.02);
    hlasitost.gain.exponentialRampToValueAtTime(0.0001, kontext.currentTime + 0.35);

    oscilator.connect(hlasitost);
    hlasitost.connect(kontext.destination);
    oscilator.start();
    oscilator.stop(kontext.currentTime + 0.36);
  } catch (_) {
    // Zvuk je príjemnosť navyše, nie funkcia.
  }
}

export default zapipaj;
